import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../parts/card';
import '../parts/monster';
import '../parts/event';
import '../components/comments';

import style from './area.scss';
import { DATA_AREAS } from '../data/sources';
import { getNameFromURL, setTitle, trackPage } from '../shared/utils';

export class AreaPage extends LitElement {

    static get properties() {
        return {
            name: String
        }
    }

    constructor() {
        super();
        this.name = null;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        this.name = getNameFromURL();
        setTitle(this.name);        
    }

    render() {
        const cls = DATA_AREAS.filter(c => c.name === this.name)[0];
        setTitle(cls.areaName.replace('<br>',' '));        
        return html` 
            <h1>${unsafeHTML(cls.areaName.replace('<br>',' '))}</h1>
            <p>${cls.desc}</p>
            ${cls.openingevent ? html`
            <h3>Opening Event</h3>
            <div class="row">
                <event-part id=${cls.openingevent}></event-part>
            </div>
            `: ''}
            ${cls.events.length > 0 ? html`
            <h3>Events</h3>
            ${cls.events.map(ev => html`
                <div class="row">
                    <event-part id=${ev.name}></event-part> x ${ev.qty}
                </div>
            `)}
            `: ''}            
            ${cls.areaEffects.length > 0 ? html`
            <h3>Area Effects</h3>
            ${cls.areaEffects.map(eff => html`
                <div class="row">
                    <card-part id=${eff}></card-part>
                </div>
            `)}
            `: ''}
            ${cls.areaSpecificEvents.length > 0 ? html`
            <h3>Area Events</h3>
            ${cls.areaSpecificEvents.map(ev => html`
                <div class="row">
                    <event-part id=${ev}></event-part>
                </div>
            `)}
            `: ''}
            ${cls.questEvents.length > 0 ? html`
            <h3>Quest Events</h3>
            ${cls.questEvents.map(ev => html`
                <div class="row">
                    <event-part id=${ev}></event-part>
                </div>
            `)}
            `: ''}
            ${cls.areaEnemies.length > 0 ? html`
            <h3>Enemies</h3>
            ${cls.areaEnemies.map(en => html`
                <div class="row">
                    <monster-part id=${en}></monster-part>
                </div>
            `)}
            `: ''}
            ${cls.miniBosses.length > 0 ? html`
            <h3>Mini Boss</h3>
            ${cls.miniBosses.map(en => html`
                <div class="row">
                    <monster-part id=${en}></monster-part>
                </div>
            `)}
            `: ''}
            ${cls.boss ? html`
            <h3>Boss</h3>
            <div class="row">
                <monster-part id=${cls.boss}></monster-part>
            </div>
            `: ''}
            ${cls.closingevent ? html`
            <h3>Closing Event</h3>
            <div class="row">
                <event-part id=${cls.closingevent}></event-part>
            </div>
            `: ''}
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('area-page', AreaPage);